const labels = {
  updated_review_required: 'Updated — review required',
  not_reviewed: 'Not reviewed',
  reviewed_accurate: 'Reviewed',
  changes_requested: 'Needs changes',
  configured: 'Configured',
  not_configured: 'Not configured',
};

export default function StatusBadge({ status = 'draft' }) {
  const label = labels[status] || status.replaceAll('_', ' ');
  return <span className={`status status-${status}`}>{label}</span>;
}
